export const shouldUseTypeBasedEntityApi = () => Boolean(globalThis.useTypeBasedApi && globalThis.productSuffix);

/**
 * Returns the path/query identifier for entity routes and type-based API calls.
 * Legacy mode uses entity.id; type-based mode uses entity.type (falls back to id when type is null).
 */
export const getEntityRouteParam = entity => {
  if (!entity) return undefined;
  if (shouldUseTypeBasedEntityApi() && entity.type != null) {
    return entity.type;
  }
  return entity.id;
};

/**
 * In type-based mode the route param used to load an entity IS its type. If the loaded entity payload
 * carries no `type`, getEntityRouteParam would fall back to entity.id and build links (records, breadcrumbs,
 * record details) with an id the type-based API cannot resolve ("Entity with Type '<id>' not found").
 * Stamp the route param onto the entity so every downstream link uses the same segment as the URL.
 */
export const withRouteType = (entity, routeParam) => {
  if (!entity || routeParam == null || routeParam === '') return entity;
  if (!shouldUseTypeBasedEntityApi() || entity.type != null) return entity;
  return { ...entity, type: String(routeParam) };
};

/** Wraps getEntityRouteParam for service methods that expect `{ id }` (mapArgs renames to type in v2). */
export const getEntityServiceIds = entity => ({ id: getEntityRouteParam(entity) });

/** Route param from useParams is already the correct segment value for the active API mode. */
export const getEntityServiceIdsFromRouteParam = routeParam => ({ id: routeParam });

/** Display label for an entity: title-first when type-based API is active, name-first otherwise. */
export const getEntityDisplayLabel = entity => {
  if (!entity) return undefined;
  return shouldUseTypeBasedEntityApi() ? entity.title ?? entity.name : entity.name ?? entity.title;
};
